import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { useFetch } from "../../lib/useFetch";
import { api, errMsg, eur, fmtDate } from "../../lib/api";

const KIND = {
  completed_overpaid: ["Paid more than the balance", "Refund the difference in PayPal or record it as credit."],
  completed_unrecorded: ["Money taken, payment not recorded", "Record the payment on the enrolment (Record payment, method PayPal)."],
};

export const PayPalAlerts = ({ onChange }) => {
  const { data, reload } = useFetch("/admin/paypal/alerts");
  const resolve = async (a) => {
    const note = window.prompt("Mark as checked. Optional note (e.g. refunded on PayPal):", "");
    if (note === null) return;
    try {
      await api.post(`/admin/paypal/alerts/${a.paypal_id}/resolve`, { note });
      toast.success("Alert marked as checked");
      reload();
      onChange?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!data?.length) return null;
  return (
    <div className="mb-8 space-y-2" data-testid="paypal-alerts">
      <p className="flex items-center gap-2 font-display text-lg font-bold text-[#0A2540]"><AlertTriangle size={18} className="text-amber-500" />PayPal payments to check ({data.length})</p>
      {data.map((a) => {
        const [title, hint] = KIND[a.status] || [a.status, ""];
        return (
          <div key={a.paypal_id} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-300 bg-amber-50 p-4 text-sm" data-testid={`paypal-alert-${a.paypal_id}`}>
            <div className="space-y-1">
              <p><b>{title}</b> · {a.order_number} · {a.user?.first_name} {a.user?.last_name} ({a.user?.email}) · {fmtDate(a.completed_at || a.updated_at || a.created_at)}{a.mode === "sandbox" ? " · Sandbox" : ""}</p>
              <p>PayPal paid <b>{eur(a.amount)}</b>{a.status === "completed_overpaid" && <> · recorded {eur(a.recorded)} · overpaid <b>{eur(a.overpaid)}</b></>}</p>
              <p className="font-mono text-xs" data-testid={`paypal-alert-ref-${a.paypal_id}`}>PayPal capture ID <b>{a.capture_id || "-"}</b> · PayPal order ID {a.paypal_id}</p>
              <p className="text-xs text-slate-500">{hint}</p>
              {a.alert_email_status && <p className="text-xs text-slate-500" data-testid={`paypal-alert-email-${a.paypal_id}`}>Alert email to admin: {a.alert_email_status === "sent" ? "sent" : `not delivered (${a.alert_email_status})`}</p>}
            </div>
            <button onClick={() => resolve(a)} className="btn-buoy !py-1.5" data-testid={`paypal-alert-resolve-${a.paypal_id}`}>Mark as checked</button>
          </div>
        );
      })}
    </div>
  );
};
